import React from 'react';
import { Checkboard as CheckboardComponent } from 'react-color/lib/components/common';
import { Colors } from '../../colors';
export const Checkboard = ({ size = 6, white = Colors.GS0, grey = Colors.GS500, }) => {
    return React.createElement(CheckboardComponent, { size: size, white: white, grey: grey });
};
